(() => {
  const panel = document.getElementById('dipsy-location-recommendation');
  if (!panel || window.Shopify?.designMode) return;
  const form = panel.querySelector('form');
  const countryCodes = JSON.parse(panel.dataset.countries);
  const countryNames = JSON.parse(panel.dataset.countryNames);
  const countries = Object.fromEntries(countryCodes.map((code, index) => [code, countryNames[index]]));
  const currentCountry = panel.dataset.country;
  const currentLanguage = panel.dataset.language;
  const root = panel.dataset.root;
  const choiceKey = 'dipsy_locale_choice';
  const checkedKey = 'dipsy_locale_checked_v1';
  let manuallyChosen = false;
  const hasChoice = () => document.cookie.split(';').some(value => value.trim().startsWith(choiceKey + '=1'));
  const remember = () => {
    manuallyChosen = true;
    document.cookie = choiceKey + '=1; Path=/; Max-Age=31536000; SameSite=Lax; Secure';
    panel.hidden = true;
  };
  const markChecked = () => {
    try { sessionStorage.setItem(checkedKey, '1'); } catch (_) {}
  };
  const addReturnPath = (targetForm, choice = 'manual') => {
    const url = new URL(window.location.href);
    url.searchParams.set('dipsy_locale', choice);
    let input = targetForm.querySelector('[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      targetForm.append(input);
    }
    input.value = url.pathname + url.search + url.hash;
  };
  const incomingUrl = new URL(window.location.href);
  if (['manual', 'auto'].includes(incomingUrl.searchParams.get('dipsy_locale'))) {
    if (incomingUrl.searchParams.get('dipsy_locale') === 'manual') remember();
    markChecked();
    incomingUrl.searchParams.delete('dipsy_locale');
    history.replaceState(history.state, '', incomingUrl.pathname + incomingUrl.search + incomingUrl.hash);
  }
  document.addEventListener('submit', event => {
    const targetForm = event.target;
    if (!(targetForm instanceof HTMLFormElement)) return;
    if (!targetForm.querySelector('[name="country_code"], [name="locale_code"], [name="language_code"]')) return;
    remember();
    addReturnPath(targetForm);
  }, true);
  panel.querySelector('[data-location-stay]').addEventListener('click', remember);
  let checked = false;
  try { checked = sessionStorage.getItem(checkedKey) === '1'; } catch (_) {}
  if (hasChoice() || checked || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;
  const euCountries = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
  const euDomains = new Set('at be bg hr cy cz dk ee fi fr de gr hu ie it lv lt lu mt nl pl pt ro sk si es se eu'.split(' '));
  const languageFor = country => ['DE', 'AT', 'CH'].includes(country) ? 'de' : 'en';
  const setTarget = country => {
    form.elements.country_code.value = country;
    form.elements.locale_code.value = languageFor(country);
  };
  const run = async () => {
    try {
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
        credentials: 'same-origin',
        signal: AbortSignal.timeout(5000)
      });
      if (!response.ok) return;
      const data = await response.json();
      if (manuallyChosen || hasChoice()) return;
      const country = data.detected_values?.country?.handle;
      if (!country || !Object.hasOwn(countries, country)) return;
      const language = languageFor(country);
      markChecked();
      if (country === currentCountry && language === currentLanguage) return;
      setTarget(country);
      const requiresChoice = country !== currentCountry && euCountries.has(country) && euDomains.has(location.hostname.split('.').pop());
      if (requiresChoice) {
        panel.querySelector('[data-location-country]').textContent = countries[country];
        panel.querySelector('[data-location-language]').textContent = language === 'de' ? panel.dataset.german : panel.dataset.english;
        panel.hidden = false;
        return;
      }
      addReturnPath(form, 'auto');
      form.submit();
    } catch (_) {}
  };
  run();
})();

